import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import {BASE_URL, BUSINESS} from "../../constants";
import {reportErrors} from "../../helpers";
import SelectField from "../../components/SelectField";
import Divider from "@mui/material/Divider";

export default function ReviewComments(props) {
    const [data, setData] = useState([]);
    const [businessType, setBusinessType] = useState(window.$user?.company?.businessType);

    useEffect(() => {
        loadData();
    }, [businessType]);
    const loadData = () => {
        let url = `${BASE_URL}api/review-comments?data=data`;
        if (businessType) {
            url += `&businessType=${businessType}`;
        }

        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    return (
        <Box>
            <SelectField
                required={true}
                placeholder="Business Type"
                options={BUSINESS}
                value={businessType}
                onChange={(value) => setBusinessType(value)}
            />
            <Divider/>
            <List sx={{width: '100%', maxWidth: '100%', bgcolor: 'background.paper'}}>
                {data.map((e, index) => (
                    <ListItem alignItems="flex-start" key={index}>
                        <ListItemText
                            primary=""
                            secondary={
                                <React.Fragment>
                                    <Typography
                                        sx={{display: 'inline'}}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                    >
                                        {e?.created}
                                    </Typography>
                                    {` — ${e?.answer}`}
                                </React.Fragment>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}